import { createFileRoute, redirect } from "@tanstack/react-router";

// /cars has no dedicated listing page — the fleet listing lives at /fleet.
// Redirect (301-equivalent) so any external link or search-engine reference
// to /cars resolves to the real listing page.
export const Route = createFileRoute("/cars/")({
  beforeLoad: () => {
    throw redirect({ to: "/fleet", statusCode: 301 });
  },
});
